import dayjs from "dayjs";

import { formatDateLocale } from "@/shared/utils/formatDate";
import { colors } from "@/Utils";

export const INIT_FEED_DATA = {
  legendLabel: [],

  seriesData: [],
  initSelectedArray: [],
  date: [],
};

const LABEL_NAMES = {
  BRAND_EQUITY_SALE: "brand_equity_sale",
  OTHER_SALE: "other_sale",
};

export const handleSourceData = ({ sourceData, setFeedData, colorTheme, config }) => {
  try {
    if (sourceData?.date) {
      const date = sourceData.date.map((date) =>
        formatDateLocale(dayjs(date), { yearFormat: "YY" })
      );
      const { showReturnInsteadOfRevenue } = config;

      let legendLabel = [];

      let seriesData = [];
      let initSelectedArray = {};

      let stackLabelName = [];
      const order = [LABEL_NAMES.OTHER_SALE, LABEL_NAMES.BRAND_EQUITY_SALE];
      stackLabelName = Object.keys(sourceData.brand_equity);
      stackLabelName.sort((a, b) => order.indexOf(a) - order.indexOf(b));

      stackLabelName.forEach((stackName) => {
        const name = stackName;

        const { color, borderColor } = generateLegendColor({
          name: name,
          colorTheme: colorTheme,
        });

        switch (stackName.toLowerCase()) {
          case LABEL_NAMES.BRAND_EQUITY_SALE:
            stackName = `Total ${showReturnInsteadOfRevenue ? "return" : "sales"} driven by Brand Equity`;
            break;
          case LABEL_NAMES.OTHER_SALE:
            stackName = `Other total ${showReturnInsteadOfRevenue ? "return" : "sales"}`;
            break;
        }

        legendLabel.push({
          name: stackName,
          itemStyle: {
            color,
            borderColor,
            borderWidth: 2,
          },
        });

        const data = date.map((dateVal, index) => {
          return {
            name: dateVal,
            value: sourceData.brand_equity[name][index],
            itemStyle: {
              color,
              borderColor,
              borderWidth: 2,
            },
          };
        });

        seriesData.push({
          label: stackName,
          name: stackName,
          type: "bar",
          stack: "1",
          fill: true,
          lineTension: 0,
          borderWidth: 2,
          borderCapStyle: "butt",
          pointHoverBorderWidth: 2,
          pointBorderWidth: 1,
          pointHitRadius: 10,
          data: data,
          barMaxWidth: 40,
        });
        initSelectedArray[stackName] = true;
      });

      setFeedData({
        legendLabel,
        seriesData,
        initSelectedArray,
        date,
      });
    }
  } catch (error) {
    setFeedData(INIT_FEED_DATA);
  }
};

const generateLegendColor = ({ name, colorTheme }) => {
  let color = colors.black;
  let borderColor = colors.black;

  try {
    switch (name.toLowerCase()) {
      case LABEL_NAMES.BRAND_EQUITY_SALE:
        if (colorTheme.mode === "light") {
          color = "rgba(88, 137, 216, 0.8)";
          borderColor = "#5889D8";
        } else {
          color = "rgba(255, 255, 183, 0.8)";
          borderColor = "#fefeeb";
        }
        break;
      case LABEL_NAMES.OTHER_SALE:
        color = "rgba(0,0,0, 0.6)";
        borderColor = "black";
        break;
    }
  } catch (error) {
    // pass
  }
  return { color: color, borderColor: borderColor };
};
